import ptBrTranslations from './pt-br'
import enUsTranslations from './en'

// eslint-disable-next-line
export default {
    'pt-BR': ptBrTranslations,
    'en-US': enUsTranslations
}
